import React, { useEffect,useState } from "react";
import Chart from "react-apexcharts";
import { useSelector, useDispatch } from "react-redux";
// import { fetchServiceDashboardData } from "../../../redux/slices/serviceDashboardSlice";
import { fetchServiceDashboardData } from "../../../../redux/reducers/serviceDashboardSlice";
const NonMedicalServicesChart = () => {
  const dispatch = useDispatch();
  const { nonmedical, loading, error } = useSelector((state) => state.serviceDashboard);
  const [noData, setNoData] = useState(false);
  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    dispatch(fetchServiceDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (!nonmedical || !Array.isArray(nonmedical) || nonmedical.length === 0) {
      setNoData(true);
      setSeries([]);
      setCategories([]);
      return;
    }

    setNoData(false);
    setSeries([{ data: nonmedical.map((item) => item.total) }]);
    setCategories(nonmedical.map((item) => item.serviceName));
  }, [nonmedical]);

  const options = {
    chart: { type: "bar", height: 350, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
    dataLabels: { enabled: true, offsetX: 5 },
    colors: ["#f34c78", "#a5e3dc", "#8cb6fc", "#737373", "#b077ff"],
    xaxis: {
      categories: categories,
      labels: { style: { fontSize: "14px" } },
    },
    grid: {
      show: true,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
    },
    tooltip: {
      y: { formatter: (val) => `₹ ${val.toLocaleString("en-IN")}` },
    },
  };

  return (
    <div className="chart-card" style={{ background: "#fff", padding: 20, borderRadius: 8 }}>
      <h3>Frequently Used Non-Medical Services</h3>
      {noData ? (
        <p style={{ color: "gray", textAlign: "center", marginTop: 20 }}>
          No data available for non-medical services.
        </p>
      ) : (
        <Chart options={options} series={series} type="bar" height={300} />
      )}
    </div>
  );
};

export default NonMedicalServicesChart;